<template>
  <question-base-wrapper
    v-bind="baseWrapperProps"
  >
    <validation-provider
      v-slot="{ failed, failedRules }"
      :vid="`${stepId}_${questionId}`"
      :name="questionId"
      rules="required"
      :data-unit-test="`${stepId}_${questionId}`"
    >
      <radio
        v-model="vehicleAlarmModel"
        :name="`${stepId}-${questionId}`"
        :items="constants.YES_NO"
        :error="failed"
        :error-messages="getFieldErrors('field', failedRules)"
        :data-test="snakeCase(questionFields.field)"
      />
    </validation-provider>
    <template #subsection="{observer}">
      <form-row
        v-if="vehicleAlarmModel"
        :error="formObserver.validated && observer.failed"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_${questionId}`"
          :name="questionId"
          rules="listOptionRequired"
        >
          <v-select
            v-model="questionData[questionFields.field]"
            :items="vehicleAlarmOptions"
            :error-messages="errors"
            :placeholder="helpers.getPlaceholderResponsiveText(optionsConfig.placeholder || 'Please select', isMobile)"
            outlined
            hide-details="auto"
            required
            :data-test="`${snakeCase(questionFields.field)}_type`"
          />
        </validation-provider>
      </form-row>
    </template>
  </question-base-wrapper>
</template>

<script>
import { omit } from 'lodash';
import QuestionBase from './Base';
import QuestionBaseWrapper from './BaseWrapper';

export default {
  name: 'question-base-vehicle-alarm',
  extends: QuestionBase,
  components: { QuestionBaseWrapper },
  data () {
    return { fields: ['field'] };
  },
  computed: {
    vehicleAlarmModel: {
      get () {
        const current = this.questionData[this.questionFields.field];
        if (current === null) return null;
        return current !== '1';
      },
      set (val) {
        this.questionData[this.questionFields.field] = val ? '' : '1';
      },
    },
    vehicleAlarmOptions () {
      return this.helpers.createOptions({ source: omit(this.optionsConfig.options, ['1']) });
    },
  },
};
</script>
